
import { useState } from "react"
import { Paper, Button, TableContainer, Table, TableHead, TableRow, TableCell, TablePagination, TableBody } from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles'
import { formatDinero } from "./../../../utils/formatDinero"
import { useSelector, useDispatch } from "react-redux"
import EstatusReserva from "../Estatus"
import { useHistory } from "react-router-dom"
import { obtenerReservasAuthPaginaAction, obtenerReservasAuthRegistrosAction, obtenerVoucherDowloadAuthAction } from "./../../../ducks/reservasAuthDuck"
import BackDrop from "../../../global/BackDrop"
import TVoucher from "./TVoucher"
const columns = [
    { id: "numero", minWidth: 50, align: "center", label: "Nombre" },
    { id: "referencia", minWidth: 50, align: "center", label: "Referencia" },
    { id: "np", minWidth: 50, align: "center", label: "Num Pax" },
    { id: "montoPaquete", minWidth: 50, align: "center", label: "Monto paquete" },
    { id: "montoProveedor", minWidth: 50, align: "center", label: "Monto Proveedor" },
    { id: "estatus", minWidth: 50, align: "center", label: "Estatus" },
    { id: "detalles", minWidth: 50, align: "center", label: "Detalles" },
    { id: "voucher", minWidth: 50, align: "center", label: "Voucher" },
]
const useStyles = makeStyles({
    containerRoot: {
        marginTop: "25px",
        marginBottom: "25px"
    },
    containerRootButton: {
        marginTop: "25px",
        marginBottom: "25px",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center"
    },
    root: {
        width: '100%',
        padding: '0'
    },
    container: {
        maxHeight: 440,
    },
})
const TReservasAutorizadas = () => {
    const { reservas, total, pagina, registroPagina } = useSelector(store => store.reservasAuth)
    const rows = reservas ?? []
    const classes = useStyles()
    const dispatch = useDispatch()
    const history = useHistory()
    const [load, setLoad] = useState(false)
    const handleChangePage = (event, newPage) => {
        setLoad(true)
        dispatch(obtenerReservasAuthPaginaAction({ Pagina: newPage })).then(Response => {
            setLoad(false)
        })
    }
    const handleChangeRowsPerPage = (event) => {
        setLoad(true)
        dispatch(obtenerReservasAuthRegistrosAction({ Registros: +event.target.value })).then(Response => {
            setLoad(false)
        })
    }
    const handleDetalle = (referencia) => {
        history.push(`/ClienteReferenciaReserva/${referencia}`, {
            reservas: true
        })
    }
    return (
        <div className={classes.containerRoot}>
            <Paper className={classes.root}>
                <TableContainer className={classes.container}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                {columns.map((column) => (
                                    <TableCell
                                        key={column.id}
                                        align={column.align}
                                        style={{ minWidth: column.minWidth }}
                                    >
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((row, index) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row?.Meta?.Id_Meta}>
                                        <TableCell align='center'>
                                            {row?.Meta?.contratacion?.Cliente}
                                        </TableCell>
                                        <TableCell align='center'>
                                            {row?.Meta?.Referencia}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row?.Meta?.Paquete?.Numero_Personas}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${formatDinero(row?.Meta?.Paquete?.Monto_Paquete)} ${row?.Meta?.Paquete?.Cotizacion?.Moneda?.Clave}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${formatDinero(row?.Compra?.MontoProveedor)} ${row?.Compra?.moneda?.Clave}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            <EstatusReserva estatus={row?.Compra?.estatusCompra?.idEstatusCompra} />
                                        </TableCell>
                                        <TableCell align="center">
                                            <Button
                                                variant="outlined"
                                                color="primary"
                                                onClick={() => { handleDetalle(row?.Meta?.Referencia) }}
                                            >
                                                Ver
                                            </Button>
                                        </TableCell>
                                        <TableCell align="center">
                                            <TVoucher Compra={row?.Compra} />
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={total}
                    rowsPerPage={registroPagina}
                    page={pagina}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
            <BackDrop open={load} />
        </div>
    )
}
export default TReservasAutorizadas